import { createEntityAdapter, createReducer } from '@reduxjs/toolkit';
import { smppboxFetchFailureAction, smppboxFetchRequestAction, smppboxFetchSuccessAction } from './smppboxActions';
import { SmppboxStateModel } from './smppboxStateModel';
import { SmppboxModel } from '../../models/smppboxModel';

export const smppboxAdapter = createEntityAdapter<SmppboxModel>({
  selectId: smppbox => smppbox.serverId,
});

const initialState: SmppboxStateModel = smppboxAdapter.getInitialState({
  fetchingStatus: {},
});

export const initialSmppboxFetchingStatus = {
  loading: false,
  errors: [],
};

export const smppboxReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(smppboxFetchRequestAction, (state, action) => {
      state.fetchingStatus = {
        ...state.fetchingStatus,
        [action.payload.serverId]: {
          loading: true,
          errors: [],
        },
      };
    })
    .addCase(smppboxFetchSuccessAction, (state, action) => {
      const oldFetchingState = state.fetchingStatus[action.payload.serverId];

      state.fetchingStatus = {
        ...state.fetchingStatus,
        [action.payload.serverId]: {
          ...oldFetchingState,
          loading: false,
        },
      };

      smppboxAdapter.setOne(state, action.payload);
    })
    .addCase(smppboxFetchFailureAction, (state, action) => {
      const oldFetchingState = state.fetchingStatus[action.payload.serverId];

      state.fetchingStatus = {
        ...state.fetchingStatus,
        [action.payload.serverId]: {
          loading: false,
          errors: [
            ...oldFetchingState.errors,
            action.payload.error,
          ],
        },
      };
    });
});

